import {
  classNames,
  FlexCenter,
  Media,
  SkeletonLine,
  TextLabel,
} from "@opensea/ui-kit"
import { useFormContext, useWatch } from "react-hook-form"
import { useTranslations } from "use-intl"
import type { CreateOfferFlowFormValues } from "../../types"
import { BestOfferButton } from "./BestOfferButton"
import { SetPriceInput } from "./SetPriceInput"

type Props = {
  className?: string
  offerSymbol: string
}

export const CreateOfferFlowHeaderActions = ({
  className,
  offerSymbol,
}: Props) => {
  const t = useTranslations("wallet.CreateOfferFlowHeaderActions")
  const { control } = useFormContext<CreateOfferFlowFormValues>()
  const offers = useWatch({ control, name: "offers" })

  return (
    <FlexCenter className={classNames("gap-3 md:mr-10 xl:mr-0", className)}>
      <Media greaterThanOrEqual="md">
        <TextLabel className="whitespace-nowrap" size="2xs">
          {t("setPriceTo", { count: offers.length })}
        </TextLabel>
      </Media>
      <BestOfferButton />
      <SetPriceInput offerSymbol={offerSymbol} />
    </FlexCenter>
  )
}

export const CreateOfferFlowHeaderActionsSkeleton = ({
  className,
  count = 1,
}: {
  className?: string
  count?: number
}) => {
  const t = useTranslations("wallet.CreateOfferFlowHeaderActions")
  return (
    <FlexCenter className={classNames("gap-3 md:mr-10 xl:mr-0", className)}>
      <Media greaterThanOrEqual="md">
        <TextLabel className="whitespace-nowrap" size="2xs">
          {t("setPriceTo", { count })}
        </TextLabel>
      </Media>
      <SkeletonLine className="h-8 w-full md:w-[68px]" />
      <SkeletonLine className="h-8 w-full md:w-[120px]" />
    </FlexCenter>
  )
}
